/*=========================================================================================
  File Name: moduleNoteState.js
  Description: Note Module State
==========================================================================================*/

export default {
	notes: [],
	total: 0,
	limitPerPage: 5,
	isHasMorePages: null
};
